import { Modal } from "@/components/data-display/modal";
import { Input } from "@/components/inputs/input";
import { Button } from "@/components/ui/button";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";

import { useBooking } from "../../hooks/use-booking";
import {
  DeleteBookingFormData,
  ModalDeleteBookingProps,
} from "./modal-delete-booking.types";
import { DeleteBookingSchema } from "./modal-delete-booking.validation";

export const ModalDeleteBooking = ({
  detail,
  open,
  handleCloseModal,
}: ModalDeleteBookingProps) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { isValid },
  } = useForm<DeleteBookingFormData>({
    resolver: yupResolver(DeleteBookingSchema),
    mode: "onBlur",
    reValidateMode: "onChange",
  });

  const { handleDeleteBooking } = useBooking();

  useEffect(() => {
    reset();
  }, [handleCloseModal]);

  const onSubmit = async (data: DeleteBookingFormData) => {
    const dataFormatted = {
      cancel_date: data.cancel_date,
      id: detail?.id,
    };

    await handleDeleteBooking(dataFormatted);
    handleCloseModal();
    setTimeout(() => {
      window.location.reload();
    }, 3500);
  };

  return (
    <Modal
      type="submit"
      title="Tem certeza que deseja cancelar este Bookão?"
      open={open}
      handleClose={handleCloseModal}
      handleConfirm={() => {}}
      enableButton={isValid}
    >
      <div className="border-[1px] border-gray-100 rounded-md overflow-hidden">
        <div className="bg-slate-100 p-2 flex">
          Private room booking
          <p className="font-bold ml-2">#{detail?.id}</p>
        </div>
        <div className="p-4">
          <ul>
            <li>
              <span className="font-bold">Empresa: </span>
              {detail?.companies.name} - {detail?.companies.id}
            </li>
            <li>
              <span className="font-bold">Espaço: </span>
              {detail?.spaces.name}
            </li>
            <li>
              <span className="font-bold">Sala privada: </span>
              {detail?.privateRooms?.label}
            </li>
          </ul>
        </div>
      </div>
      <div className="py-5">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            control={control}
            name="cancel_date"
            render={({ field, fieldState }) => (
              <Input
                {...field}
                label="Data de cancelamento"
                name="cancel_date"
                type="date"
                showlabel={true}
                value={field.value || ""}
                onChange={(event) => {
                  field.onChange(event);
                }}
                required
                error={fieldState.error ? fieldState.error.message : ""}
              />
            )}
          />
          <div className="mt-5">
            <Button type={"submit"} disabled={!isValid}>
              Cancelar
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
